<template>
  <div class="home">
    <div id="companies-table" class="data-table">
      <div class="header">
        <div class="id">ID</div>
        <div>Company Name</div>
        <div>Business Code</div>
        <div>VAT Code</div>
        <div>License Type</div>
        <div>Fee %</div>
        <div>Contact %</div>
        <div>Promo %</div>
        <div>Order %</div>
        <div>Flags</div>
        <div>API keys</div>
        <div>Balance</div>
        <div>Departments</div>
        <div>CreatedAt</div>
      </div>
      <div
        v-for="company in companies"
        v-bind:key="company.id"
        class="row"
      >
        <div class="cell id">{{ company.id }}</div>
        <div class="cell">
          <router-link :to="{ name: 'companyPage', params: { id: company.id } }">{{
            company.name
          }}</router-link>
        </div>
        <div class="cell">{{ company.businessCode }}</div>
        <div class="cell">{{ company.vatCode }}</div>
        <div class="cell">{{ company.licenseType }}</div>
        <div class="cell">{{ (company.feePercentage || 0).toFixed(5) | percent }}</div>
        <div class="cell">{{ (company.contactBonusPercentage || 0).toFixed(2) | percent }}</div>
        <div class="cell">{{ (company.promoBonusPercentage || 0).toFixed(2) | percent }}</div>
        <div class="cell">{{ (company.orderBonusPercentage || 0).toFixed(2) | percent }}</div>
        <div class="cell">{{  [company.orderCodePrefix, company.expensesAccountingStrategy, company.invoicesRecipient].join(':') }}</div>
        <div class="cell">{{ company.apiKeyCount }}</div>
        <div class="cell">{{ Math.round(company.balance * 100) / 100 }}</div>
        <div class="cell">{{ (company.departmentsList || []).length }}</div>
        <div class="cell">
          {{
            company.createdAt
              ? new Date(company.createdAt.seconds * 1000).toLocaleDateString()
              : "-"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
#companies-table {
  grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto auto auto auto;
  .row.disabled .cell {
    color: #aaa;
  }
  .cell input {
    padding: 10px;
  }
  .inputcell {
    padding: 0;
  }
  @media only screen and (max-width: 1000px) {
    .cell.id {
      display: none;
    }
    .header .id {
      display: none;
    }
    grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto auto auto;
  }
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from "../services/api";

export default {
  name: "home",
  data: function() {
    return {
      companies: [],
    };
  },
  filters: {
    percent: (dec) => {
      if (dec <= 1) {
          return (dec * 100).toFixed(3) + "%";
      }
      return 'Please enter number less than or equal to 1'
    }
  },
  async created() {
    document.title = 'Companies';
    this.companies = (await api.getCompanies()).sort(
      (v1, v2) => {
        const coef1 = v1.licenseType ? 1 : 2;
        const coef2 = v2.licenseType ? 1 : 2;
        return v1.createdAt.seconds * coef1 - v2.createdAt.seconds * coef2;
      }
    );
  }
};
</script>
